// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__RIycr","title_wrapper":"Table_title_wrapper__zA7Rf"};